import { DragDropProvider } from '@dnd-kit/react';
import { isSortable } from '@dnd-kit/react/sortable';
import { useAppSelector } from 'hooks/useAppSelector';
import { Tab } from 'routes/essential-workspace/components/side-panel/tab';
import { useTabPersistence } from 'routes/essential-workspace/hooks/use-tab-persistence';

export function Tabs() {
  const formIds = useAppSelector(s => s.workspaces.workspaces.essential.tabs);
  const { moveTab } = useTabPersistence({ workspace: 'essential' });

  return (
    <DragDropProvider
      onDragEnd={event => {
        const { source } = event.operation;

        if (isSortable(source)) {
          moveTab(source.initialIndex, source.index);
        }
      }}
    >
      <ul className="list-group list-group-flush border-top border-opacity-40">
        {formIds.map((formId, index) => (
          <Tab key={formId} formId={formId} index={index} />
        ))}
      </ul>
    </DragDropProvider>
  );
}
